export const STATUS_STYLES = {
  pending: { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", dot: "bg-amber-500", label: "Pending" },
  approved: { bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-700", dot: "bg-emerald-500", label: "Approved" },
  not_approved: { bg: "bg-red-50", border: "border-red-200", text: "text-red-700", dot: "bg-red-500", label: "Not Approved" },
};

export const TIMELINESS_STYLES = {
  on_time: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "On Time" },
  late: { bg: "bg-orange-50", text: "text-orange-700", border: "border-orange-200", label: "Late" },
  no_show: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", label: "No Show" },
  not_recorded: { bg: "bg-slate-50", text: "text-slate-500", border: "border-slate-200", label: "Not Recorded" },
};

export function StatusBadge({ status, testid }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.pending;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.bg} ${s.border} ${s.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}

export function TimelinessBadge({ value }) {
  const s = TIMELINESS_STYLES[value] || TIMELINESS_STYLES.not_recorded;
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${s.bg} ${s.border} ${s.text}`}>
      {s.label}
    </span>
  );
}

export function VisitTypeBadge({ type }) {
  const supervised = type !== "unsupervised";
  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${
        supervised ? "border-indigo-200 bg-indigo-50 text-indigo-700" : "border-slate-200 bg-slate-50 text-slate-600"
      }`}
    >
      {supervised ? "Supervised" : "Unsupervised"}
    </span>
  );
}

export function RescheduleNote({ history }) {
  if (!history || history.length === 0) return null;
  const last = history[history.length - 1];
  return (
    <p className="mt-2 flex items-center gap-1.5 text-xs text-slate-400">
      <span className="inline-block h-1 w-1 rounded-full bg-slate-300" />
      Rescheduled from {last.from_date} {last.from_start}
      {history.length > 1 ? ` (·${history.length} times)` : ""}
    </p>
  );
}

function Stars({ value }) {
  return (
    <span className="inline-flex gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <span key={n} className={n <= value ? "text-[#0d9488]" : "text-slate-300"}>★</span>
      ))}
    </span>
  );
}

export function QualitySummary({ assessment, testid }) {
  if (!assessment) return null;
  const p = assessment.punctuality;
  const puncStyle = p === "no_show" ? "bg-red-50 text-red-700" : p === "late" ? "bg-orange-50 text-orange-700" : "bg-emerald-50 text-emerald-700";
  const puncLabel = p === "no_show" ? "No Show" : p === "late" ? "Not On Time" : "On Time";
  return (
    <div data-testid={testid} className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-3">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-slate-500">Documented Quality</p>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-1.5 text-xs text-slate-600">
        <span className="flex items-center gap-1.5">Engagement <Stars value={assessment.engagement} /></span>
        <span className="flex items-center gap-1.5">Emotional safety <Stars value={assessment.emotional_safety} /></span>
        <span className={`rounded px-1.5 py-0.5 font-medium ${puncStyle}`}>{puncLabel}</span>
      </div>
      {assessment.observation_note && (
        <p className="mt-2 text-sm italic text-slate-700">"{assessment.observation_note}"</p>
      )}
      {assessment.documented_by && (
        <p className="mt-1.5 text-[11px] text-slate-400">Documented by {assessment.documented_by}</p>
      )}
    </div>
  );
}
